//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    mixins: [],
    data() {
        return {
            memberRechargeOrderId: '', // 会员充值订单
            orderPrice: '', // 订单价格
            accountNumber: '', // 会员手机号
            currentUserInfo: {
                // 用户信息
                accountId: '', //用户id
                displayName: '', // 用户名
                expireTime: '', // 到期时间
                queryTime: '', // 查询时间  这里也做充值时间
                username: '' // 手机号
            },
            careObjectList: [] // 已守护长者
        };
    },
    methods: {
        // 获取支付结果
        getPaymentResults() {
            let that = this;
            that.$axios
                .get('/api/v1.0/wechatOrder', {
                    params: {
                        orderId: that.memberRechargeOrderId
                    }
                })
                .then(function(response) {
                    console.log('获取会员充值订单支付结果：' + response);
                    // that.packageData = response.body.data;
                    if (response.body.data[0].orderStatus == 2) {
                        that.getUserInfoByPhoneNum();
                    }
                });
        },
        // 查询用户信息通过手机号
        getUserInfoByPhoneNum() {
            let that = this;
            that.$axios
                .get('/api/v1.0/familyApp/vip/wechat/account', {
                    params: {
                        phoneNum: that.accountNumber
                    }
                })
                .then(function(response) {
                    console.log('获取用户信息：' + response);
                    that.currentUserInfo = response.body.account;
                    let tmp = Date.parse(new Date()).toString();
                    tmp = tmp.substr(0, 10);
                    that.currentUserInfo.queryTime = tmp;
                    that.careObjectList = response.body.careObjectList;
                });
        },
        //  返回
        returnInquiry() {
            this.$router.go(-2);
        },
        //  继续充值
        continueToRecharge() {
            this.$router.go(-1);
        },
        // 时间戳格式化
        timestampToTime(value) {
            if (value && value != '0') {
                return this.$moment(value * 1000).format('YYYY-MM-DD HH:mm');
            }
        }
    },
    mounted() {
        // this.$store.state.rechargeResultPAGE = this;
        if (this.$store.state.memberInfo) {
            this.accountNumber = this.$store.state.memberInfo.currentUserInfo.username;
        }
        if (this.$route.query) {
            this.memberRechargeOrderId = this.$route.query.memberRechargeOrderId;
            this.orderPrice = this.$route.query.price;
        }
        this.getPaymentResults();
    }
};



// WEBPACK FOOTER //
// ./src/components/member/rechargeResult.vue